import { OptionProps } from 'react-select';
import { tPaymentMethodOption } from '../../SubscriptionManager.types';
import { eCardBrand } from '../../SubscriptionManager.enums';
import CardBrand from './CardBrand.component';

export default function CardSelectorOption(
  props: OptionProps<tPaymentMethodOption>,
) {
  const { innerRef, innerProps } = props;
  return (
    <div
      ref={innerRef}
      {...innerProps}
      className="flex flex-row items-center px-2 py-2 hover:bg-gray-100 cursor-pointer"
    >
      <CardBrand brand={props.data.brand as eCardBrand} />
      <p className="SubscriptionCheckout__paymentMethods__selectedPaymentMethod__cardNumber">
        •••• •••• •••• {props.data.lastDigits}
      </p>
    </div>
  );
}
